
import React from 'react';
import Layout from '@/components/Layout/Layout';
import BlogPost from '@/components/Blog/BlogPost';
import BlogSidebar from '@/components/Blog/BlogSidebar';

const BlogPostPage = () => {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-3">
            <BlogPost />
          </div>
          <div className="lg:col-span-1">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default BlogPostPage;
